import React from 'react'
import './time.css'
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import StarIcon from '@material-ui/icons/Star';
import ExploreIcon from '@material-ui/icons/Explore';
import CodeIcon from '@material-ui/icons/Code';
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import LanguageIcon from '@material-ui/icons/Language';
import PieChartIcon from '@material-ui/icons/PieChart';
import StorageIcon from '@material-ui/icons/Storage';
import ImportantDevicesIcon from '@material-ui/icons/ImportantDevices';

function Time() {
    return (
        <div className = 'time'>
            <div className = 'time_header'>
                <h1>HOW IT STARTED</h1>
            </div>
            <VerticalTimeline lineColor = {'#10CC52'}>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
                    date="2018 - 2019"
                    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    icon={<ExploreIcon/>}
                >
                    <h3 className="vertical-timeline-element-title">Explore Fields</h3>
                    <h4 className="vertical-timeline-element-subtitle">Start of my journey</h4>
                    <p>In my initial year of engineering I started exploring different fields in development like front-end and back-end development, Machine Learning and AI, Information Security and Linux.</p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="2018 - 2019"
                    contentStyle={{ background: 'rgb(167, 85, 191)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgb(167, 85, 191)' }}
                    iconStyle={{ background: 'rgb(167, 85, 191)', color: '#fff' }}
                    icon={<CodeIcon/>}
                >
                    <h3 className="vertical-timeline-element-title">Data Structures</h3>
                    <h4 className="vertical-timeline-element-subtitle">Basic Fundamentals</h4>
                    <p>I attempted to improve my core CS skills, such as OOPs, by utilising C/C++, as well as data structures and algorithms.</p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="2019 - 2020"
                    contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
                    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    icon={<LaptopMacIcon/>}
                >
                    <h3 className="vertical-timeline-element-title">Competitive Coding</h3>
                    <h4 className="vertical-timeline-element-subtitle">Using Python</h4>
                    <p>After experimenting with a variety of programming languages, I discovered that Python was my favourite due to its flexibility and vast choice of modules. Then I began honing my coding abilities by competing in online coding contests like as code chef and hackerrank.</p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="2019 - 2020"
                    contentStyle={{ background: 'rgb(167, 85, 191)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgb(167, 85, 191)' }}
                    iconStyle={{ background: 'rgb(167, 85, 191)', color: '#fff' }}
                    icon={<LanguageIcon/>}
                >
                    <h3 className="vertical-timeline-element-title">Web Development</h3>
                    <h4 className="vertical-timeline-element-subtitle">Front-End using HTML,CSS,JS</h4>
                    <p>I began by studying basic html, CSS, and a few javascript effects in order to develop a small website. To develop my web design abilities, I used the help of YouTube, codepen, and w3classes.</p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    date="2020 - 2021"
                    contentStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgb(233, 30, 99)' }}
                    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
                    icon={<StorageIcon/>}
                >
                    <h3 className="vertical-timeline-element-title">Django (python framework)</h3>
                    <h4 className="vertical-timeline-element-subtitle">Database Design (Back-End)</h4>
                    <p>I grew interested in back-end development in addition to front-end programming. I created a couple django-related projects, which can be seen in my project section and on my git profile as well.</p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    date="2021 - present"
                    contentStyle={{ background: 'rgb(255, 161, 1)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgb(255, 161, 1)' }}
                    iconStyle={{ background: 'rgb(254,190,11)', color: '#fff' }}
                    icon={<ImportantDevicesIcon/>}
                >
                    <h3 className="vertical-timeline-element-title">React Js</h3>
                    <h4 className="vertical-timeline-element-subtitle">Advance Web Development</h4>
                    <p>After learning basic html, CSS, and javascript, I began working on reactjs, a javascript framework. To learn reactjs, I used YouTube and numerous reactjs documentations. I developed many web sites using reacts along with firebase database as well. Some of my works are  there in project section.</p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    date="2021 - present"
                    contentStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgb(233, 30, 99)' }}
                    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
                    icon={<PieChartIcon/>}
                >
                    <h3 className="vertical-timeline-element-title">Exploring Machine Learning and AI</h3>
                    <h4 className="vertical-timeline-element-subtitle">Using Python and it's Modules</h4>
                    <p>I am now investigating the subject of machine learning and AI using Python. Learning various ML models and how to use them in various cases. I'm utilising python modules such as Numpy, Pandas, scikit-learn, matplotlib, and jupyter-notebook.</p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
                    icon={<StarIcon />}
                />
                </VerticalTimeline>
        </div>
    )
}

export default Time
